export default __webpack_public_path__ + "img/bmwUcnvO.3f4aa5f9.svg";